"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.timeout = exports.retry = exports.defaultRetryDelay = exports.createBackOffDelay = exports.retryableError = exports.defaultRetryableResponses = exports.defaultBackOffConfig = exports.retryFactor = void 0;
/**
 * This is an abstracted helper for connector retry
 * Replace the internalRetry with other retry algorithm (jitter etc.)
 */
var error_1 = require("./error");
var networkUtils = require("./network");
exports.retryFactor = 2;
exports.defaultBackOffConfig = {
    retries: 6,
    timeoutInMs: 1000,
};
/*
NOTE: this should be kept in sync with:
https://confluence.oci.oraclecorp.com/display/DEX/Error+Codes#ErrorCodes-Priority
ALSO, several things are intentionally omitted:
- 409/NotAuthorizedOrResourceAlreadyExists is omitted because we don't automatically retry on POST
- 400/RelatedResourceNotAuthorizedOrNotFound and 404/NotAuthorizedOrNotFound are omitted because there's no way except
  to try an API to discern permissions and waiting for an entire backoff to find out they can't do something can
  cause massive delays in the logic that would conditionally render things due to the guess-and-check methodoligy.
*/
exports.defaultRetryableResponses = [
    { status: 429 },
    { status: 401, code: "NotAuthenticated" },
    { status: 409, code: "IncorrectState" },
    { status: 500 },
    { status: 503 },
];
function retryableError(retryResponses) {
    return function (error) {
        return retryResponses.some(function (value) {
            if (value.code) {
                return (error.status === error_1.ConnectionStatus.Offline ||
                    (error.status === value.status && error.body.code === value.code));
            }
            return error.status === value.status;
        });
    };
}
exports.retryableError = retryableError;
/**
 * Helper function for configurable retry with back-off, this should make it easier for plugin devs to
 * create their own custom nextRetryDelay() function.
 */
function createBackOffDelay(backOffConfig, isRetryable) {
    return function (error, currentRetryAttempt) {
        if (isRetryable(error) && currentRetryAttempt < backOffConfig.retries) {
            return (Math.pow(exports.retryFactor, currentRetryAttempt) * backOffConfig.timeoutInMs);
        }
        else if (currentRetryAttempt === backOffConfig.retries) {
            console.debug("[connectorRetry] Maximum retry attempts reached");
        }
    };
}
exports.createBackOffDelay = createBackOffDelay;
exports.defaultRetryDelay = createBackOffDelay(exports.defaultBackOffConfig, retryableError(exports.defaultRetryableResponses));
var defaultRetryOptions = {
    nextRetryDelay: exports.defaultRetryDelay,
};
function retry(fn, options) {
    if (options === void 0) { options = defaultRetryOptions; }
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, internalRetry(fn, 0, options)];
        });
    });
}
exports.retry = retry;
function internalRetry(fn, currentTry, options) {
    return __awaiter(this, void 0, void 0, function () {
        var _this = this;
        return __generator(this, function (_a) {
            return [2 /*return*/, fn().catch(function (error) { return __awaiter(_this, void 0, void 0, function () {
                    var currentTimeout;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                currentTimeout = options.nextRetryDelay(error, currentTry);
                                if (!(typeof currentTimeout === "number")) return [3 /*break*/, 5];
                                if (!networkUtils.isOnline()) return [3 /*break*/, 2];
                                return [4 /*yield*/, timeout(currentTimeout)];
                            case 1:
                                _a.sent();
                                return [3 /*break*/, 4];
                            case 2: return [4 /*yield*/, networkUtils.waitUntilOnline()];
                            case 3:
                                _a.sent();
                                _a.label = 4;
                            case 4: return [2 /*return*/, internalRetry(fn, currentTry + 1, options)];
                            case 5: return [2 /*return*/, Promise.reject(error)];
                        }
                    });
                }); })];
        });
    });
}
/**
 * Helper function wrapping a setTimeout inside a promise, which enable async/await on setTimeout.
 */
function timeout(millis) {
    return new Promise(function (resolve) { return setTimeout(resolve, millis); });
}
exports.timeout = timeout;
//# sourceMappingURL=retry.js.map